import $ from 'jquery';
import * as pbi from 'powerbi-client';

export function PowerembedReport(reportEmbedData) {
  $(function () {

    const models = pbi.models;
    const languageToLoad = reportEmbedData.locale && reportEmbedData.locale.languageId ? reportEmbedData.locale.languageId : "en";

    const basicFilter = {
      $schema: 'http://powerbi.comproduct/schema#basic',
      target: {
        table: "Languages",
        column: "LanguageId"
      },

      operator: "In",
      values: [languageToLoad],    // <- Filter based on Spanish
      filterType: models.FilterType.Basic,
      requireSingleSelection: true
    };

    const config = {
      type: 'report',
      id: reportEmbedData.ReportId,
      tokenType: models.TokenType.Embed,
      accessToken: reportEmbedData.EmbedToken,
      embedUrl: reportEmbedData.EmbedUrl,
      viewMode: reportEmbedData.ViewMode ? models.ViewMode.Edit : models.ViewMode.View,
      permissions: reportEmbedData.OnlyCopy ? models.Permissions.Copy : models.Permissions.All,
      filters: [basicFilter],
      settings:
      {
        filterPaneEnabled: false,
        localeSettings: { language: reportEmbedData.locale && reportEmbedData.locale.defaultCulture ? reportEmbedData.locale.defaultCulture : "en-US" },
        panes: {
          pageNavigation: {
            visible: true
          }
        },
        bars: {
          statusBar: {
            visible: true
          }
        }
      },
    };

    const isSlicer = visual => visual.type === 'slicer';
    const isPageActive = page => page.isActive;

    const reportContainer = $("#report-container").get(0);


    // Embed Power BI report when Access token and Embed URL are available
    // The access token is valid for 60 minutes and will need to be refreshed after 
    window.powerbi.reset(reportContainer);
    
    const report = window.powerbi.embed(reportContainer, config);


    // console.log(report);

    //apply filter
    // function applyFilter() {
    //   // report.setFilters([]);
    //   console.log("Applying filter", basicFilter);
    //   report.setFilters(basicFilter);
    // }
    // applyFilter();

    // Clear any other loaded handler events
    report.off("loaded");

    // Triggers when a report schema is successfully loaded
    report.on("loaded", function () {
      console.log("Report load successful");
    });

    // Clear any other rendered handler events
    report.off("rendered");


    // Triggers when a report is successfully embedded in UI
    report.on("rendered", function () {
      console.log("Report render successful");
      report.getPages().then(pages => {
        const activePage = pages.filter(isPageActive)[0];
        activePage.getVisuals().then(visuals => {
          const slicers = visuals.filter(isSlicer);
          const filteredSlicers = [];
          slicers.forEach(async slicer => {
            slicer.getSlicerState().then(slicerState => {
              if (slicerState.filters.length > 0) { filteredSlicers.push(slicerState) }
            })
          })
          setTimeout(() => {
            localStorage.setItem('filterdata', JSON.stringify(filteredSlicers));
            localStorage.setItem('reportrendered', JSON.stringify("true"));
          }, 300);
        })
      });
    });


    // Clear any other error handler events
    report.off("error");

    // Handle embed errors
    report.on("error", function (event) {
      const errorMsg = event.detail;

      // Use errorMsg variable to log error in any destination of choice
      console.error(errorMsg);
      return;
    });
  });
}